/**
 * Formate un numéro de téléphone avec espaces
 * Format français : "06 12 34 56 78"
 * Format international : "+33 6 12 34 56 78"
 *
 * @param {string} phoneNumber - Numéro brut
 * @returns {string} - Numéro formaté avec espaces
 */
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return '';
  }

  const cleaned = phoneNumber.replace(/[\s\-.()]/g, '');

  if (cleaned.length === 10 && cleaned[0] === '0') {
    return cleaned.match(/.{1,2}/g).join(' ');
  }

  if (cleaned.startsWith('+')) {
    const country = cleaned.slice(0, 3);
    const rest = cleaned.slice(3);
    const formatted = rest.match(/.{1,2}/g);
    return formatted ? `${country} ${formatted.join(' ')}` : phoneNumber;
  }

  return phoneNumber;
};

/**
 * Masque un numéro de téléphone au format "07 54 12 ** **"
 * Garde les 6 premiers chiffres visibles, masque le reste
 *
 * @param {string} phoneNumber - Numéro de téléphone complet
 * @returns {string} - Numéro masqué avec astérisques
 */
export const maskPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || phoneNumber.trim() === '') {
    return '****';
  }

  const cleaned = phoneNumber.replace(/[\s\-.()]/g, '');

  if (cleaned.length < 6) {
    return '****';
  }

  const start = cleaned.slice(0, 6);
  const restLength = Math.max(0, cleaned.length - 6);
  const rest = '*'.repeat(restLength);

  const masked = start + rest;

  return formatPhoneNumber(masked);
};
